export const validationUserPassword = (password) => {
  // 密码长度必须大于等于10位，包含字母、数字和符号
  // validationUserPassword("Ex@mpl3P@ssw0rd");  应返回true
  // validationUserPassword("Short123");  应返回false，因为长度不足10位
  // validationUserPassword("LongButNoSymbol1234567890"); 应返回false，因为缺少符号
  const passwordRegex =
    /^(?=.{10,})(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`])(?!.*\s).*$/
  if (!password) return
  return passwordRegex.test(password)
}
